import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=58f2efa9&scoped=true&"
import script from "./AgentList.vue?vue&type=script&lang=js&"
export * from "./AgentList.vue?vue&type=script&lang=js&"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=58f2efa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f2efa9",
  null
  
)

export default component.exports